import { jwtDecode } from "jwt-decode"
export const lintCottonSubmit =  (items) => {
    const token = sessionStorage.getItem("token")
    const user = jwtDecode(token)
    
    //Alert if the file is empty.
    if(items.length === 0){
        alert("Please select at least one item.")
        return
    }

    for(let i = 0; i < items.length; i++){

        items[i].product_id = "1"
        items[i].product = "Cotton"
        items[i].by_product_id ="14"
        items[i].by_product = "lint_cotton"

        if(items[i].date){
            items[i].date = new Date(items[i].date)
        }

        //Seller check: if availbale then add this
        if (items[i].province_id) {
           // console.log(items[i].province_id, typeof items[i].province_id)
            items[i].province_id = Number(items[i].province_id);
        }
        
        if (items[i].province) {
            items[i].province = String(items[i].province);
        }
        
        if (items[i].district_id) {
            items[i].district_id = String(items[i].district_id);
        }

        if(items[i].station_id){
            items[i].station_id = String(items[i].station_id);
        }

        if(items[i].station){
            items[i].station = String(items[i].station);
        }

        if(items[i].rate){
            items[i].minimum = Number(items[i].rate);
            items[i].maximum = Number(items[i].rate);
        }

        if(items[i].seller){
            items[i].seller = String(items[i].seller)
        }
        
        if(items[i].buyer){
            items[i].buyer = String(items[i].buyer)
        }

        //Check if quality type is there or not
        if(items[i].quality_type){
            items[i].quality_type = String(items[i].quality_type)
        }

        //Check if deal_type exists
        if(items[i].deal_type){
            items[i].deal_type = String(items[i].deal_type)
        }

        //Check if cents per pound exists
        if(items[i]['c/lbs']){
            items[i]['c/lbs'] = Number(items[i]['c/lbs'])
        }

        //Check if bales exists
        if(items[i].bales){
            items[i].bales = Number(items[i].bales)
        }

        delete items[i].rate

        //Append the username who has uploaded.
        items[i].user_name = user.userName
       
    }
    return items
}
